export default __webpack_public_path__ + "static/media/LQI_image.6fef094f.webp";